import { Box, Flex, Heading, Image, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
import RewardsButton from 'ui/rewards/RewardsButton';
import AdBanner from 'ui/shared/ad/AdBanner';
import SearchBar from 'ui/snippets/searchBar/SearchBar';
import UserProfileDesktop from 'ui/snippets/user/profile/UserProfileDesktop';
import UserWalletDesktop from 'ui/snippets/user/wallet/UserWalletDesktop';

const BACKGROUND_DEFAULT = '#FFFFFF';
const TEXT_COLOR_DEFAULT = 'black';
const BORDER_DEFAULT = '0.5px solid rgba(19,19,19,0.20)';

const HeroBanner = () => {
  const background = useColorModeValue(
    // light mode
    config.UI.homepage.heroBanner?.background?.[0] ||
      config.UI.homepage.plate.background ||
      BACKGROUND_DEFAULT,
    // dark mode
    config.UI.homepage.heroBanner?.background?.[1] ||
      config.UI.homepage.heroBanner?.background?.[0] ||
      config.UI.homepage.plate.background ||
      '#0A0A0A',
  );

  const textColor = useColorModeValue(
    // light mode
    config.UI.homepage.heroBanner?.text_color?.[0] ||
      config.UI.homepage.plate.textColor ||
      TEXT_COLOR_DEFAULT,
    // dark mode
    config.UI.homepage.heroBanner?.text_color?.[1] ||
      config.UI.homepage.heroBanner?.text_color?.[0] ||
      config.UI.homepage.plate.textColor ||
      'white',
  );

  const border = useColorModeValue(
    BORDER_DEFAULT,
    '0.5px solid rgba(255,255,255,0.20)',
  );

  return (
    <Flex
      w="100%"
      display="flex"
      position="relative"
      background={ background }
      border={ border }
      borderRadius="md"
      p={{ base: 4, lg: 12 }}
      columnGap={ 8 }
      alignItems="center"
    >
      <Box flexGrow={ 1 }>
        <Flex
          mb={{ base: 2, lg: 8 }}
          justifyContent="space-between"
          alignItems="center"
          columnGap={ 2 }
        >
          <Heading
            as="h1"
            fontSize={{ base: '18px', lg: '30px' }}
            lineHeight={{ base: '24px', lg: '36px' }}
            fontWeight={{ base: 500, lg: 700 }}
            color={ textColor }
          >
            { config.meta.seo.enhancedDataEnabled ?
              `${ config.chain.name } blockchain explorer` :
              `${ config.chain.name } explorer` }
          </Heading>
          { config.UI.navigation.layout === 'vertical' && (
            <Box display={{ base: 'none', lg: 'flex' }} gap={ 2 }>
              { config.features.rewards.isEnabled && (
                <RewardsButton variant="hero"/>
              ) }
              { (config.features.account.isEnabled && (
                <UserProfileDesktop buttonVariant="hero"/>
              )) ||
                (config.features.blockchainInteraction.isEnabled && (
                  <UserWalletDesktop buttonVariant="hero"/>
                )) }
            </Box>
          ) }
        </Flex>
        <SearchBar isHomepage/>
      </Box>
      <Image src="/static/tabi_banner.png" width="230px" top="2px" right="89px" height="230px" position="absolute"/>
      <AdBanner
        platform="mobile"
        w="fit-content"
        flexShrink={ 0 }
        borderRadius="md"
        overflow="hidden"
        display={{ base: 'none', lg: 'block ' }}
      />
    </Flex>
  );
};

export default React.memo(HeroBanner);
